import "./About.css";
const About = () => {
    return(
        <div className="about-body">
            <h1 className="about-header1">About</h1>
            <p className="about-p1">
            We're actually kind of washed
            <br/><br/>
            </p>
            <div className="about-spacer"></div>
        </div>
    )
}
export default About;